export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/PY-98ce0d64abc29d8b2632ff5a9f3a4ec4.png";